import { apiHelper } from "@/utils";
import { API } from "@/constants";

export const lookupService = {
    getMeetingRooms
};

const MODULE = {
    MEETING_ROOM: "meeting-rooms",
};

const API_URL = API.BASE_URL_APP + '/v1';

export function getMeetingRooms() {
    return apiHelper(API_URL).get(`/lookup/${MODULE.MEETING_ROOM}`);
}